import { render, staticRenderFns } from "./TariffPlan.vue?vue&type=template&id=dbf279a0&"
import script from "./TariffPlan.vue?vue&type=script&lang=js&"
export * from "./TariffPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports